import React, {useContext, useEffect, useRef, useState} from "react";
import {AppContext} from "../../context/App.context";
import {Button, Modal, Tooltip} from 'antd';
import styles from "./UIModalPlayRecord.module.scss";
import crossIcon from "../../../assets/png/crossIcon.png";
import ReplayIcon from './images/replay.svg';
import IconStop from './images/stop-button.svg';

var janus: any;
var recordPlay: any;
//@ts-ignore
var opaqueId = "wconf-" + window.Janus.randomString(12);

const UIModalPlayRecord = (props: any) => {
    const { fileId } = props;

    const [isPlaying, setPlaying] = useState(false);

    const playRecord = useRef();
    const appCtx: any = useContext(AppContext);

    useEffect(() => {
        console.log("IsOpen", props.isOpen);
        if (props.isOpen && appCtx.janusPlugin) {
            janus = appCtx.janusPlugin;
            console.log("Start record");
            initRecord();
        }
    }, [props.isOpen, appCtx.janusPlugin]);

    function initRecord() {
        console.log("opaqueId: ", opaqueId);
        try {
            janus.attach({
                plugin: "janus.plugin.recordplay",
                opaqueId: opaqueId,
                success: function (pluginHandle: any) {
                    recordPlay = pluginHandle;
                    //@ts-ignore
                    window.Janus.log(
                        "Plugin attached! (" +
                        recordPlay.getPlugin() +
                        ", id=" +
                        recordPlay.getId() +
                        ")"
                    );
                    startPlayout();
                },
                error: function (error: any) {
                    //@ts-ignore
                    window.Janus.error("  -- Error attaching plugin...", error);
                    // bootbox.alert("  -- Error attaching plugin... " + error);
                },
                consentDialog: function (on: any) {
                    //@ts-ignore
                    window.Janus.debug(
                        "Consent dialog should be " + (on ? "on" : "off") + " now"
                    );
                },
                webrtcState: function (on: any) {
                    //@ts-ignore
                    window.Janus.log(
                        "Janus says our WebRTC PeerConnection is " +
                        (on ? "up" : "down") +
                        " now"
                    );
                    // $("#videobox").parent().unblock();
                },

                onmessage: function (msg: any, jsep: any) {
                    //@ts-ignore
                    window.Janus.debug(" ::: Got a message :::");
                    //@ts-ignore
                    window.Janus.debug(msg);

                    if (msg["error_code"] !== null && msg["error_code"] !== undefined) {
                        if (msg["error_code"] == 416) {
                            console.error(msg);
                            // setTimeout(startPlayout, 3000);
                        }
                        return;
                    }

                    var result = msg["result"];
                    if (result !== null && result !== undefined) {
                        if (result["status"] !== undefined && result["status"] !== null) {
                            var event = result["status"];
                            if (event === "preparing" || event === "refreshing") {
                                //@ts-ignore
                                window.Janus.log("Preparing the recording playout");
                                recordPlay.createAnswer({
                                    jsep: jsep,
                                    media: { audioSend: false, videoSend: false }, // We want recvonly audio/video
                                    success: function (jsep: any) {
                                        //@ts-ignore
                                        window.Janus.debug("Got SDP!");
                                        //@ts-ignore
                                        window.Janus.debug(jsep);
                                        var body = { request: "start" };
                                        recordPlay.send({ message: body, jsep: jsep });
                                    },
                                    error: function (error: any) {
                                        //@ts-ignore
                                        window.Janus.error("WebRTC error:", error);
                                        // bootbox.alert("WebRTC error... " + JSON.stringify(error));
                                    },
                                });
                                if (result["warning"]) {
                                    //@ts-ignore
                                    window.Janus.log("warning");
                                }
                                // bootbox.alert(result["warning"]);
                            } else if (event === "recording") {
                                // Got an ANSWER to our recording OFFER
                                if (jsep) recordPlay.handleRemoteJsep({ jsep: jsep });
                                var id = result["id"];
                                if (id !== null && id !== undefined) {
                                    //@ts-ignore
                                    window.Janus.log("The ID of the current recording is " + id);
                                }
                            } else if (event === "slow_link") {
                                var uplink = result["uplink"];
                                if (uplink !== 0) {
                                }
                            } else if (event === "playing") {
                                //@ts-ignore
                                window.Janus.log("Playout has started!");
                                console.log("Playing has started : ", msg);
                            } else if (event === "stopped") {
                            }
                        }
                    } else {
                        // FIXME Error?
                        var error = msg["error"];
                    }
                },
                onlocalstream: function (stream: any) {
                    //@ts-ignore
                    window.Janus.log(" ::: Got a onlocalstream notification :::");
                },
                onremotestream: function (stream: any) {
                    //@ts-ignore
                    window.Janus.log(" ::: Got a onremotestream notification :::");
                    //@ts-ignore
                    window.Janus.debug(" ::: Got a remote stream :::");
                    //@ts-ignore
                    window.Janus.debug(stream);
                    //@ts-ignore
                    window.Janus.attachMediaStream(playRecord.current, stream);
                    setPlaying(true);
                },
                oncleanup: function () {
                    //@ts-ignore
                    window.Janus.log(" ::: Got a cleanup notification :::");
                    recordPlay.current = null;
                    setPlaying(false);
                },
            });
        } catch (error) {
            console.error(error);
        }
    }

    function startPlayout() {
        let play = { request: "play", id: fileId };
        console.log("play record req:", play);

        recordPlay.send({ message: play });
    }

    function stop() {
        try {
            let stop = { "request": "stop" };
            recordPlay.send({ "message": stop });
            recordPlay.hangup();
        } catch (e) {

        }
    }

    function replay() {
        try {
            let stop = { "request": "stop" };
            recordPlay.send({ "message": stop });
            recordPlay.hangup();

            initRecord();
        } catch (e) {

        }
    }

    return (
        <Modal
            visible={props.isOpen}
            onCancel={() => {
                stop();
                props.onClose()
            }}
            centered
            className={styles.modalOverride}
        >
            <div onClick={() => {
                stop();
                props.onClose()
            }}
                 className={styles.closeBtn}
                 style={{ backgroundImage: `url(${crossIcon})` }}
            />
            <div className={styles.boxCreate}>
                <div style={{position: "relative"}}>
                    <video
                        width="100%"
                        //@ts-ignore
                        ref={playRecord}
                        // controls
                        autoPlay
                        playsInline
                        className={styles.recordVideo}
                    />
                    <div className={styles.replayContainer}>
                        {isPlaying ?
                            <Tooltip title="Stop">
                                <Button type="text" onClick={stop}>
                                    <img src={IconStop} width="22px" height="22px" alt=""/>
                                </Button>
                            </Tooltip>
                            :
                            <Tooltip title="Replay">
                                <Button type="text" onClick={replay}>
                                    <img src={ReplayIcon} width="22px" height="22px" alt=""/>
                                </Button>
                            </Tooltip>
                        }
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default UIModalPlayRecord;
